export default {
  lang: ({ lang }) => lang,
  selectedLang: ({ selectedLang }) => selectedLang,
  currentEmailTemplate: ({ currentEmailTemplate }) => currentEmailTemplate,
  currentTemplateRiskID: ({ currentTemplateRiskID }) => currentTemplateRiskID,
}
